/**
 * Created by Thomas Mark
 * Date: 2019-10-29
 * 
 * Versionen verwalten
 * 
 * In diesem Dialog können alle Versionen in einer Liste angezeigt,
 * erstellt, geändert oder gelöscht werden.
 *
 */
import React from 'react'
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { Redirect } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { MdPlayCircleOutline } from 'react-icons/md';

import * as utils from "../../../basics/utils";
import * as appActions from "../../../store/actions/appActions"
import * as syncActions from "../../../store/actions/syncActions"
import * as versionActions from '../../../store/actions/versionActions'
import * as portfolioActions from '../../../store/actions/portfolioActions'

import db from '../../../basics/db';
import Header from "../../partials/Header";
import Footer from "../../partials/Footer";
import { ConfirmModal } from "../../partials/ConfirmModal";
import ProgressBar from "../../partials/ProgressBar";
import ProgressView from "../../partials/ProgressView";
import VersionModal from "./VersionModal";
import DownloadConfirmModal from "../containers/DownloadConfirmModal";


import { Icon } from '../../partials/Icons';

const styles = (theme) => ({
    root: {
        width: '100%',
    },
    versionLive: {
        backgroundColor: 'red',
        color: 'white',
        left: '10px'
    },
    versionDraft: {
        backgroundColor: 'green',
        color: 'white'
    },
    versionArchiv: {
        backgroundColor: 'gray',
        color: 'white'
    }
});

class VersionsController extends React.Component {
    constructor(props) {
        super(props);

        this.component = 'VersionsController';

        this.state = {
            tabIndex: 2,
            currentProgress: 0,
            objectViewType: 'MP4',

        }
        this.documentList = [];
        this.storedFiles = []
    }

    // ==========================================================================
    //
    // LIFESYCLE - SECTION
    //
    // ==========================================================================

    componentDidMount = () => {
        const debug = false;

        debug && console.log(`\n\n##################################################`);
        debug && console.log(`${this.component}:Mount`);
        debug && console.log(`##################################################\n\n`);

        this.props.setModalDialog(null, null);

        this.props.getVersionList();
    }

    componentWillUnmount = () => {
        const debug = false;

        debug && console.log(`\n\n##################################################`);
        debug && console.log(`${this.component}:Unmount`);
        debug && console.log(`##################################################\n\n`);
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { windowHeight, headerHeight, toolbarHeight, inputHeight, unitHeight, isSafari, currentContainer } = this.props.app;
        const { progress, syncCounter, syncList, syncAdmin, syncType } = this.props.sync;
        const { version, classes, portfolio } = this.props;
        const { loginUser } = this.props.user;

        this.documentList = syncList;

        /**
         * Liste aller Versionen in einer Tabelle anzeigen
         */
        const renderTable = () => {

            const columns = [
                { id: 'id', label: 'Version', minWidth: 10, align: 'center' },
                { id: 'version', label: 'Beschreibung', minWidth: 300, align: 'left', format: (value) => value.toLocaleString('de-DE') },
                { id: 'timestamp', label: 'Datum/Uhrzeit', minWidth: 50, align: 'right', format: (value) => utils.toSqlDatetime(value) },
                { id: 'sync', label: 'Download', minWidth: 0, align: 'center' },
                { id: 'action', label: 'Aktion', minWidth: 0, align: 'center' },
            ];

            if (!version.versionList.length) {
                return (
                    <Typography className="p-8" variant="h6" >Keine Datensätze vorhanden!</Typography>
                )
            }

            // ###############################################################
            // Kopfzeile der Tabelle anzeigen
            // ###############################################################
            const renderHead = () => {
                const getCellValue = (column) => { return column.label }

                return (
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                {getCellValue(column)}
                            </TableCell>
                        ))}
                    </TableRow>
                )
            }

            // ###############################################################
            // Einzelne Zeile der Tabelle anzeigen
            // ###############################################################
            const renderItem = (d, i) => {

                if (d.id === 0 || d.id === 1) return null;

                const getCellValue = (column, d, i) => {
                    // ==========================================================================
                    // ID-Spalte
                    // ==========================================================================
                    if (column.id === 'id') {
                        if (d.id === 0) { return (<Chip label='LIVE' className={classes.versionLive} />) }
                        if (d.id === 1) { return (<Chip label='DRAFT' className={classes.versionDraft} />) }
                        if (d.id > 1) { return (<Chip label='ARCHIVE' className={classes.versionArchiv} />) }
                    }

                    // ==========================================================================
                    // Aktion-Spalte
                    // ==========================================================================
                    if (column.id === 'action') {

                        const onEdit = (d, crudType) => {
                            this.props.getVersion(d.id, 'version', crudType);
                        }

                        const onGoLive = () => {
                            this.props.setModalDialog('ConfirmModal', 'confirmGoLive');
                        }

                        if (d.id === 1) {
                            return (
                                <div className="">
                                    <Button variant="contained" color="primary" size="small" className={classes.versionLive} onClick={onGoLive}>
                                        Go-Live
                                    </Button>
                                </div>
                            )
                        }
                        if (d.id >= 1) {
                            return (
                                <div className="space-x-4">
                                    {false && <EditIcon onClick={() => onEdit(d, 'update')} />}
                                    <DeleteIcon onClick={() => onEdit(d, 'delete')} />
                                </div>
                            )
                        }
                    }

                    // ==========================================================================
                    // EDIT-Spalte
                    // ==========================================================================
                    if (column.id === 'sync') {

                        const onSync = (d) => {
                            let sVersion = (d.id > 1) ? 'archive_' + d.id : d.version;

                            sVersion = sVersion.toLowerCase();
                            sVersion = sVersion.replace('-version', '');
                            sVersion = sVersion.replace('archive_', '');

                            this.props.setModalDialog('DownloadConfirmModal', null, { container: currentContainer, version: sVersion }); // appAction.js
                        }

                        return (
                            <div className="" onClick={() => onSync(d)}>
                                <button disabled className="inline-flex items-center focus:outline-none px-8 py-2 rounded text-white">
                                    <Icon color='gray' type='download' width={unitHeight * .35} height={unitHeight * .35} className="animate-spin" />
                                </button>
                            </div>
                        )
                    }

                    const value = d[column.id];

                    if (column.format && typeof value === 'number') return column.format(value)
                    if (column.format && column.id === 'timestamp') return column.format(value)

                    return value
                }

                // ###############################################################
                // renderItem()
                // ###############################################################
                return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={i} >
                        {columns.map((column) => {
                            return (
                                <TableCell key={column.id} align={column.align}>
                                    {getCellValue(column, d, i)}
                                </TableCell>
                            );
                        })}
                    </TableRow>
                )
            }

            // ###############################################################
            // renderTable()
            // ###############################################################
            return (
                <TableContainer className={classes.container} style={{ height: inputHeight - 40, bottom: 0 }}>
                    <Table stickyHeader >
                        <TableHead>
                            {renderHead()}
                        </TableHead>
                        <TableBody>
                            {version.versionList && version.versionList.map((d, i) => renderItem(d, i))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )
        }

        /**
         * Verlauf der Synchronisation visualisieren
         * Hier kann der Administrator in einer Liste den Downloadvorgang 
         * Live verfolgen. Sämtliche Dokumente, die heruntergeladen werden
         * werden in einer Liste angezeigt. Der Downloadfortschritt wird in
         * direkt in der Zeile im Hintergrund angezeigt.
         * 
         * ACHTUNG: Diese Funktion wird zur Zeit nicht genutzt.
         */
        const renderVisualSync = () => {
            if (!syncAdmin) return null;

            const renderItem = (d, i) => {

                const onClickItem = async (d, i) => {

                    if (d.name.endsWith(".mp4")) {
                        this.setState({ objectViewType: 'MP4' });
                        try {
                            const dbFile = await db.video.where('name').equals(d.name).first()
                            if (dbFile) {
                                window.URL = window.URL || window.webkitURL;

                                let objectURL = null

                                if (isSafari) {
                                    const fileBlob = new Blob([dbFile.data], { type: 'video/mp4' });
                                    objectURL = window.URL.createObjectURL(fileBlob);

                                } else {
                                    objectURL = window.URL.createObjectURL(dbFile.data);
                                }

                                const videoElement = document.getElementById('myVideo')
                                const sourcesElement = videoElement.getElementsByTagName('source')
                                sourcesElement[0].src = objectURL;
                                videoElement.load();
                                videoElement.play();
                            } else {
                                console.log('Video not found:', d.name);
                            }
                        } catch (error) {
                            console.log('fetchNextFile(error):', error);
                        }
                    }

                    if (d.name.endsWith(".pdf")) {
                        let sID = `${currentContainer}/${d.path}/${d.name}`;

                        this.setState({ objectViewType: 'PDF' });

                        try {
                            const file = await db.pdf.where('id').equals(sID).first()
                            if (file) {
                                window.URL = window.URL || window.webkitURL;

                                if (d.name.endsWith(".pdf")) {
                                    this.setState({ objectViewType: 'PDF' });

                                    const fileBlob = new Blob([file.data], { type: 'application/pdf' });
                                    const objectURL = window.URL.createObjectURL(fileBlob);
                                    const pdfElement = document.getElementById('myPDF');
                                    pdfElement.src = objectURL;
                                }
                            } else {
                                console.log('PDF not found:', sID);
                            }
                        } catch (error) {
                            console.log('fetchNextFile(error):', error);
                        }
                    }
                }

                const progressBar = () => {
                    if (syncType !== 'syncFiles') return null;

                    if (i === syncCounter - 1) {
                        const progressValue = (progress.currentPercent < 1) ? '' : parseInt(progress.currentPercent) + '%'

                        const styleProgressBar = Object.assign({ backgroundColor: 'rgba(145,28,33, .8)', width: (progress.currentPercent) + '%' }, utils.getStyleHeight(unitHeight, .5, .5, .2));
                        return (
                            <div className="absolute h-full leading-none text-center text-white" style={styleProgressBar}>{progressValue}</div>
                        )
                    } else {
                        return null;
                    }
                }

                const style = utils.getStyleHeight(unitHeight, .5, .5, .22)
                const styleIcon = utils.getStyleHeight(unitHeight, 1, 1, .4)

                let className = (i % 2) ? 'bg-white' : 'bg-gray-100'
                let bShowPlayButton = true

                if (syncType === '') { // sync is not running
                    if (this.storedFiles.includes(d.name)) {
                        bShowPlayButton = true
                    } else {
                        className = (i % 2) ? 'bg-gray-200' : 'bg-gray-300'
                    }
                } else { // sync is running
                    bShowPlayButton = i < syncCounter - 1
                    if (i < syncCounter) {
                        className = (i % 2) ? 'bg-gray-200' : 'bg-gray-300'
                    }
                }

                // ###############################################################
                // renderItem()
                // ###############################################################

                return (
                    <div key={i} className={"relative flex w-full h-full text-gray-500 font-mono " + className} style={style} >
                        {progressBar()}
                        <div className="w-1/12 h-full flex whitespace-no-wrap overflow-hidden justify-start px-1">{i}</div>
                        <div className="w-8/12 h-full flex whitespace-no-wrap overflow-hidden justify-start px-1">{d.name}</div>
                        <div className="w-2/12 h-full flex whitespace-no-wrap overflow-hidden justify-end   px-1">{utils.humanFileSize(d.size)}</div>
                        <div className="w-1/12 h-full flex whitespace-no-wrap overflow-hidden justify-center p-1" onClick={(e) => onClickItem(d, i)} style={styleIcon}>
                            {bShowPlayButton ? <MdPlayCircleOutline /> : null}
                        </div>
                    </div>
                );
            }

            // ###############################################################
            // renderVisualSync()
            // ###############################################################

            const style = {
                height: ((windowHeight - toolbarHeight) * .5) + 'px',
                minHeight: ((windowHeight - toolbarHeight) * .5) + 'px'
            }

            return (
                <div id='fileList' className="w-full h-full flex flex-col overflow-y-auto overflow-x-hidden bg-gray-800" style={style}>
                    {this.documentList.map((d, i) => renderItem(d, i))}
                </div>
            )
        }

        /**
         * Dokumente (PDF oder Video) anzeigen
         * Hier kann der Administrator direkt die bereits heruntergeladenen
         * Dokumente betrachten.
         * 
         * ACHTUNG: Diese Funktion wird zur Zeit nicht genutzt.
         */
        const renderDocumentViewer = (id) => {

            if (!syncAdmin) return null;

            const style = {
                height: ((windowHeight - toolbarHeight) * .5) + 'px',
                minHeight: ((windowHeight - toolbarHeight) * .5) + 'px'
            }

            if (this.state.objectViewType === 'PDF') {
                /*
                return ( <iframe id="myPDF" title="PDF Viewer" src="about:blank" frameBorder="0" className="flex w-full bg-white" style={style} /> )
                return ( <embed id="myPDF" src="" alt="pdf" type="application/pdf" target="myself" className="flex w-full bg-white" style={style} /> )
                return ( <object id="myPDF" className="flex w-full bg-white" style={style} data="">PDF Dokument</object> )
                */
                return (<embed id="myPDF" src="" alt="pdf" type="application/pdf" target="myself" className="flex w-full bg-white" style={style} />)

            } else { // this.state.objectViewType === 'MP4'
                return (
                    <video id={'myVideo'} className="flex w-full bg-black" style={style} controls muted preload="auto" autoPlay={true}>
                        <source src="" type="video/mp4" />
                    </video>
                )
            }
        }

        /**
         * Modaldialog um den GoLive zu bestätigen
         * +---------------------------------------------------+
         * | Draft-Version in Live-Version übernehmen?         |
         * +---------------------------------------------------+
         * | [ABBRUCH]                                  [ OK ] |
         * +---------------------------------------------------+
         */
        const renderGoLiveConfirm = () => {
            const debug = false;

            // #################################################################
            // GoLive wurde bestätigt
            // -----------------------------------------------------------------
            // Wurde der GoLive bestätigt, so werden zunächst mit der Funktion
            // generatePortfolio() die JSON-Dateien für jedes einzelne Portfolio
            // auf dem Server generiert. Danach wird das komplette draft-Verzeichnis
            // in das live-Verzeichnis übernommen.
            // #################################################################
            const onConfirm = () => {
                this.props.generatePortfolio(() => {
                    debug && console.log('VersionsController:generatePortfiolio(success)');

                    this.props.goLivePortfolio(() => {
                        debug && console.log('onGoLiveSuccess()');
                        this.props.closeModalDialog(); // appAction.js
                        this.props.getVersionList(); // versionsAction.js
                    }, () => {
                        debug && console.log('onGoLiveError()');
                        this.props.closeModalDialog(); // appAction.js
                    }); // syncActions.js

                }, () => {
                    console.log('VersionsController:generatePortfiolio(error)');
                }); // portfolioActions.js
            }

            // #################################################################
            // GoLive wurde nicht bestätigt
            // #################################################################
            const onCancel = () => {
                this.props.closeModalDialog();
            }

            // #################################################################
            // renderGoLiveConfirm()
            // #################################################################
            if (portfolio.type.indexOf('PENDING') !== -1) {
                return (
                    <ConfirmModal dialog='ConfirmModal' type='confirmGoLive' title="Bitte warten..." onCancel={onCancel}>
                        <div className="flex justify-start text-2xl font-bold">Version wird veröffentlicht</div>
                    </ConfirmModal>
                )
            }

            return (
                <ConfirmModal dialog='ConfirmModal' type='confirmGoLive' title="Bestätigung" onConfirm={onConfirm} onCancel={onCancel}>
                    <div className="flex justify-start text-2xl font-bold">Version veröffentlichen?</div>
                </ConfirmModal>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================
        const style = {
            top: headerHeight + 'px',
            height: inputHeight + 'px',
            minHeight: inputHeight + 'px',
            backgroundColor: 'white'
        }

        if (!loginUser) {
            console.log(this.component + ': !loginUser -> redirect to /\n\n`')
            return <Redirect to='/' />
        }

        if (!version.versionList) return null;

        const onDownloadSuccess = () => {
            console.log('onDownloadSuccess')

            this.props.setToolbarType('portfolios');

            this.props.history.push('/portfolios');

            /* #nodelay
            setTimeout(() => this.props.setToolbarType('portfolios'), 400);

            setTimeout(() => this.props.history.push('/portfolios'), 200);
            */
        }

        return (
            <div className="VersionsController absolute w-full h-full flex flex-col text-white ">
                <Header />
                {syncType === '' &&
                    <div className="w-full h-full flex flex-col" style={style}>
                        {renderTable()}
                        {renderDocumentViewer()}
                        {renderVisualSync()}
                    </div>}
                <ProgressView />
                <ProgressBar />
                {renderGoLiveConfirm()}
                <DownloadConfirmModal onSuccess={onDownloadSuccess} />
                <VersionModal />
                {(syncType !== '' && progress !== null) ? null : <Footer />}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        user: state.user,
        sync: state.sync,
        version: state.version,
        portfolio: state.portfolio,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, versionActions, syncActions, portfolioActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(VersionsController));